import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';
import { makeMediaStyles } from '../_ThemeTwo_/Utils/Styles/makeMediaStyles';
import { VALID_MEDIA_STYLES } from '../_ThemeTwo_/Utils/Styles/common';

import FormGroup, { IGroupProps } from './FormGroup';
import FormError from './FormError';

export interface IFormGroupRadioProps extends IGroupProps {
  inline?: boolean;
  columns?: number;
  gridAutoRows?: VALID_MEDIA_STYLES;
  gridTemplateColumns?: VALID_MEDIA_STYLES;
  gridGap?: VALID_MEDIA_STYLES;
  columnWidth?: string;
  fitWidth?: boolean;
}

export const FormGroupRadio = Styled(FormGroup)<IFormGroupRadioProps>`
  position: relative;

  ${media.medium`
    max-width: 51.5em;
  `}

  /* IE11 Support */
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${({ inline }) => inline ? 'row' : 'column'};

  > :not(input) {
    margin-top: 2%;

    &:nth-of-type(1) {
      margin-top: 0;
    }
  }

  ${({ inline, columns }) => inline && css`
    ${media.small`
      > :not(input) {
        width: calc((100% / ${columns}) - 2%);
        margin: 2% 2% 0 0;

        /* remove top margin from top 2 buttons */
        &:nth-of-type(-n+2) {
          margin-top: 0;
        }

        /* remove right margin from every 2nd button */
        &:nth-of-type(even) {
          margin-right: 0;
        }
      }
    `}
  `}

  /* End of IE11 Support */

  @supports (display: grid) {
    /* overwrite ie11 css, also need radio type to account for KBA checkbox stuff */
    > :not(input) {
      width: 100%;
      margin: 0;

      ${({ fitWidth }) => fitWidth && `width: fit-content;`};
    }

    display: grid;
    grid-gap: 0.625em;

    ${({ inline, columns, gridGap, columnWidth, gridAutoRows, gridTemplateColumns, fitWidth }) => media.medium`
      ${inline && !!columns && `grid-template-columns: repeat(${columns}, ${columnWidth});`}
      grid-auto-rows: ${typeof gridAutoRows === 'string' && gridAutoRows ? gridAutoRows : '1fr'};
      grid-gap: ${typeof gridGap === 'string' && gridGap};
      ${inline && gridTemplateColumns && `grid-template-columns: ${gridTemplateColumns};`}
      ${inline && fitWidth && css`
        grid-template-columns: repeat(${columns}, max-content);
      `};
    `}

    ${({ gridGap }) => typeof gridGap === 'object' && css`
      /* grid-gap */ ${gridGap && makeMediaStyles('grid-gap', gridGap)};
    `}

    ${({ gridAutoRows }) => typeof gridAutoRows === 'object' && css`
      /* grid-gap */ ${gridAutoRows && makeMediaStyles('grid-auto-rows', gridAutoRows)};
    `}

    ${({ gridTemplateColumns }) => typeof gridTemplateColumns === 'object' && css`
      /* grid-gap */ ${gridTemplateColumns && makeMediaStyles('grid-template-columns', gridTemplateColumns)};
    `}
  }

  ${FormError} {
    padding-top: 0.5em;
    clear: both;
  }
`;

FormGroupRadio.defaultProps = {
  columns: 2,
  gridGap: '1.25em',
  columnWidth: '1fr',
};

FormGroupRadio.displayName = 'FormGroupRadio';
